import { faShareSquare } from '@fortawesome/pro-light-svg-icons';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/shared/Button';
import HtmlTrans from 'components/shared/HtmlTrans';
import ShareModal from 'components/shared/ShareModal';
import TooltipMF from 'components/shared/TooltipMF';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import MethodologyAnchor from '../methodologyAnchor/MethodologyAnchor';
import {
  ShareTitle,
  StyledActions,
  StyledContainer,
  StyledDesc
} from './SectionChart.styled';
import { SectionChartProps } from './SectionChart.types';

const SectionChart: React.FC<SectionChartProps> = ({
  title,
  children,
  desc,
  descExtra,
  shareId,
  shareMessage,
  emailMessage,
  emailSubject
}) => {
  const { locale } = useRouter();

  const { t } = useI18n('developer-career-report-2025');

  const [isShareModalOpened, setIsShareModalOpened] = useState(false);

  const linkRef = useRef<HTMLButtonElement>(null);
  const [copied, setCopied] = useState(false);

  let url: string;

  if (typeof window !== 'undefined') {
    url = `${window.location.origin}/${locale}${getAppUrl(
      APP_URLS.mantechcar25,
      locale
    )}#${shareId}`;
  }

  return (
    <StyledContainer id={shareId}>
      <Heading2 as="h3" editorial alignLeft>
        <span>
          {shareId && (
            <>
              <ShareTitle
                ref={linkRef}
                onClick={() => {
                  navigator.clipboard.writeText(url);
                  setCopied(true);
                  setTimeout(() => {
                    setCopied(false);
                  }, 2000);
                }}
              >
                <FontAwesomeIcon icon={faLink} />
              </ShareTitle>
              <TooltipMF
                content={t('mantechcar25.copied')}
                direction="up"
                distance={65}
                isOpen={copied}
              ></TooltipMF>
            </>
          )}
          {title}
        </span>
      </Heading2>
      {desc && (
        <StyledDesc className="isTop">
          <HtmlTrans ns="developer-career-report-2025" i18nKey={desc} />
        </StyledDesc>
      )}

      {children}

      <StyledActions>
        {shareId && (
          <Button
            variant="secondary"
            type="button"
            onClick={() => {
              ServiceEventTracking.trackLandingCtaClicked('mandecar-compartir');
              setIsShareModalOpened(true);
            }}
          >
            <FontAwesomeIcon icon={faShareSquare} />
            <span>{t('mantechcar25.footer-share')}</span>
          </Button>
        )}
        <MethodologyAnchor />
      </StyledActions>

      {descExtra && (
        <StyledDesc>
          <HtmlTrans ns="developer-career-report-2025" i18nKey={descExtra} />
        </StyledDesc>
      )}

      {emailSubject && emailMessage && shareMessage && isShareModalOpened && (
        <ShareModal
          isOpened={isShareModalOpened}
          close={() => setIsShareModalOpened(false)}
          url={`${window.location.origin}/${locale}${getAppUrl(
            APP_URLS.mantechcar25,
            locale
          )}#${shareId}`}
          emailSubject={emailSubject}
          twitterMessage={shareMessage}
          telegramMessage={shareMessage}
          whatsappMessage={shareMessage}
          emailMessage={emailMessage}
        />
      )}
    </StyledContainer>
  );
};

export default SectionChart;
